// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"623d5ba4","312":"7de27652","416":"3e0c55bc","453":"73477e0d","455":"522b5598","471":"21f33934","479":"68c20c22","540":"41bef4a1","857":"f1e8f9c9","865":"f31bb758","959":"a3cc2f50","977":"3807472b"}[chunkId] + ".chunk.js";
};